import script from "./ListarPerfisUsuarios.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPerfisUsuarios.vue?vue&type=script&setup=true&lang=js"

import "./ListarPerfisUsuarios.vue?vue&type=style&index=0&id=9e6ee8d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e6ee8d0"]])

export default __exports__